export enum STATUS {
  ALL = 'all',
  ACTIVE = 'true',
  IN_ACTIVE = 'false',
}

export enum LIMIT {
  NO_LIMIT = '0',
}

export enum STATUS_READABLE {
  ACTIVE = 'กำลังใช้งาน',
  IN_ACTIVE = 'ปิดใช้งาน',
}

export enum PRIORITY {
  HIGH = 'High',
  MEDIUM = 'Medium',
  LOW = 'Low',
}

export enum TASK_PROGRESS {
  NEW = 'New',
  IN_PROGRESS = 'In progress',
  PENDING = 'Pending',
  REJECTED = 'Rejected',
  DONE = 'Done',
  CLOSED = 'Closed',
  TRANSFERRING = 'Transferring',
}

export enum ROLE {
  TECHNICIAN = 'technician',
  MANAGER = 'manager',
  SUPERVISOR = 'supervisor',
  ADMIN = 'admin',
}

export enum MAINTENANCE_UNIT {
  YEAR = 'YEAR',
  MONTH = 'MONTH',
  DAY = 'DAY',
  NONE = 'NONE',
}

export enum CURRENCY {
  THB = 'THB',
}
